var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 5.51269 14.4873 1.875 10 1.875ZM10 5.20833C9.65482 5.20833 9.375 5.48816 9.375 5.83333C9.375 6.17851 9.65482 6.45833 10 6.45833H10.0075C10.3527 6.45833 10.6325 6.17851 10.6325 5.83333C10.6325 5.48816 10.3527 5.20833 10.0075 5.20833H10ZM9.16667 8.54167C8.82149 8.54167 8.54167 8.82149 8.54167 9.16667C8.54167 9.51184 8.82149 9.79167 9.16667 9.79167H9.375V14.1667C9.375 14.5118 9.65482 14.7917 10 14.7917C10.3452 14.7917 10.625 14.5118 10.625 14.1667V9.16667C10.625 8.82149 10.3452 8.54167 10 8.54167H9.16667Z",
    fill: "#D802BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo2);
export default __webpack_public_path__ + "static/media/icon_info2.eaf5975b3f4d6df8a467263d64c3824b.svg";
export { ForwardRef as ReactComponent };